import React from "react"
import ReactSelect, {
    ActionMeta,
    GroupBase,
    SingleValue,
    StylesConfig,
} from "react-select"
import styles from "./styles.module.scss"
import { LabelValueOptionType } from "../../../../types/commonTypes"

export type ReactSingleSelectOptionT = LabelValueOptionType

interface ReactSingleSelectI {
    options: ReactSingleSelectOptionT[]
    onChange: (
        newValue: SingleValue<ReactSingleSelectOptionT>,
        actionMeta: ActionMeta<ReactSingleSelectOptionT>
    ) => void
    value: ReactSingleSelectOptionT
    width?: string
    menuPortalTarget?: HTMLElement | null
    isClearable: boolean
    isSearchable?: boolean
    orientation?: "horizontal" | "vertical"
    label?: string | React.ReactNode
    placeholder?: string
    styles?: StylesConfig<
        ReactSingleSelectOptionT,
        false,
        GroupBase<ReactSingleSelectOptionT>
    >
    isLoading?: boolean
}

const ReactSingleSelect: React.FC<ReactSingleSelectI> = ({
    options,
    onChange,
    value,
    menuPortalTarget,
    label,
    isClearable = false,
    styles: customStyles,
    orientation = "vertical",
    width = "400px",
    placeholder = "Select",
    isSearchable,
    isLoading,
}) => {
    return (
        <div
            className={
                orientation === "horizontal"
                    ? styles.horizontal
                    : styles.vertical
            }
        >
            {label && (
                <label
                    className={
                        orientation === "horizontal"
                            ? styles.horizontalLabel
                            : styles.verticalLabel
                    }
                >
                    {label}
                </label>
            )}
            <ReactSelect
                isLoading={isLoading}
                options={options}
                value={value}
                onChange={onChange}
                isClearable={isClearable}
                isSearchable={isSearchable}
                placeholder={placeholder}
                isOptionDisabled={(option) => option.disabled ?? false}
                menuPortalTarget={menuPortalTarget}
                closeMenuOnSelect
                styles={{
                    placeholder: (provided) => ({
                        ...provided,
                        color: "#0000008a",
                    }),
                    container: (provided) => ({
                        ...provided,
                        width: width,
                    }),
                    control: (provided) => ({
                        ...provided,
                        width: "100%",
                        height: 32,
                        minHeight: 32,
                    }),
                    option: (provided) => ({
                        ...provided,
                        backgroundColor: "#fff",
                        color: "#000",
                        ":hover": {
                            backgroundColor: "#f5f5f5",
                        },
                    }),
                    indicatorsContainer: (styles) => ({
                        ...styles,
                        paddingTop: 1,
                        paddingBottom: 1,
                    }),
                    dropdownIndicator: (styles) => ({
                        ...styles,
                        paddingTop: 1,
                        paddingBottom: 1,
                    }),
                    clearIndicator: (styles) => ({
                        ...styles,
                        paddingTop: 1,
                        paddingBottom: 1,
                    }),
                    ...customStyles,
                }}
            />
        </div>
    )
}

export default ReactSingleSelect
